import { Constants } from '../_constants/shared.constants';
const initialState = {
  containerTerminalNameLS: ' ',
  containerNumberLS: ' ',
  billOfLadingNumberLS: ' '
};
function containerReducer(state = initialState, action) {
  switch (action.type) {
    case Constants.container.CONTAINER_SUCCESS:
      return {
        ...state,
        data: action.data,
      };
    default:
      return state
  }
}
export default containerReducer;